import React from 'react';
import styles from './Button.module.scss';
import clsx from 'clsx';
const Button = ({ children, lg, onClick, disabled }) => {
  return (
    <button disabled={disabled} onClick={onClick} className={clsx(styles.btn, lg && styles.btnLg)}>
      {children}
    </button>
  );
};

export default Button;
